var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-ui-video"},[_c('video',{ref:"video",attrs:{"autoplay":_vm.autoplay,"loop":_vm.loop,"preload":_vm.preload,"src":_vm.src,"poster":_vm.poster,"playsinline":""},domProps:{"muted":_vm.muted}})])}
var staticRenderFns = []

export { render, staticRenderFns }